import { AfterContentChecked, AfterViewInit, Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, ViewChild, ViewEncapsulation, makeStateKey } from '@angular/core';
import { CommonModule, DOCUMENT, isPlatformBrowser, isPlatformServer, NgOptimizedImage } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { LayoutModule, MediaMatcher } from '@angular/cdk/layout';
import { Category, ItemService } from './pages/item-detail/item-detail.service';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { Video1Component } from './shared/video1/video1.component';
import { AppMessageService } from './app.message.service';
import { PrerenderDataService } from './prerender-data.service';
import { CdkScrollable, CdkScrollableModule } from '@angular/cdk/scrolling';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRippleModule } from '@angular/material/core';
import { InitialWelcomeScreenComponent } from './shared/initial-welcome-screen/initial-welcome-screen.component';
import { InitialWelcomeScreenSoloComponent } from './shared/initial-welcome-screen-solo/initial-welcome-screen.component';

export let APPHOST = 'https://softnetcomputers.lk';
export let APIHOST = 'https://api.softnetcomputers.lk';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule,
    NavbarComponent, MatSidenavModule, MatTooltipModule, NgOptimizedImage, InitialWelcomeScreenComponent,
    RouterModule, CdkScrollableModule, MatRippleModule, InitialWelcomeScreenSoloComponent,
    MatListModule, Video1Component, LayoutModule],
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrl: './app.component.scss',


})
export class AppComponent implements OnInit, AfterContentChecked, AfterViewInit {
  GET_ALL_CATS = makeStateKey<any>('GET_ALL_CATS');
  cats: Category[] = [];
  isMobile: boolean = true;
  // @ViewChild('snav')
  //  sidenav!: MatSidenav;
  @ViewChild('cont') cont!: ElementRef;
  @ViewChild(CdkScrollable) scrollable?: CdkScrollable;

  cookie: boolean = false;
  scrollPos: number = 0;
  showWelcomeScreen = true;
  chunkedCats: Category[][] = [];
  cat1: Category = { label: '', icon: '', slug: '', showNewState: false, mainNavItem: { id: '', label: '' }, filters: [], menuOrder: 0 };
  cat2: Category = { label: '', icon: '', slug: '', showNewState: false, mainNavItem: { id: '', label: '' }, filters: [], menuOrder: 0 };
  cat3: Category = { label: '', icon: '', slug: '', showNewState: false, mainNavItem: { id: '', label: '' }, filters: [], menuOrder: 0 };

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private msgService: AppMessageService,

    private activatedRoute: ActivatedRoute,
    private media: MediaMatcher, private itemService: ItemService,
    private prerenderDataService: PrerenderDataService,
  ) {


    if (isPlatformServer(this.platformId)) {

    }
    if (isPlatformBrowser(this.platformId)) {
      const urlObject = new URL(window.location.href); 
      if (urlObject.pathname.includes('/home') || urlObject.pathname ===('/')) {
        this.showWelcomeScreen = true;
      } else {
        this.showWelcomeScreen = false;

      }

    }



    this.isMobile = media.matchMedia('(max-width: 840px)').matches;
    try {

      if (typeof window === "undefined") {
        APPHOST = 'https://api.softnetcomputers.lk';

      } else {
        const full = location.protocol + '//' + location.host;

        if (full.includes('localhost') || full.includes('www')) {
          APPHOST = 'https://api.softnetcomputers.lk';

        } else {

          APPHOST = 'https://softnetcomputers.lk';

        }
      }

    } catch (error) {

    }


    setTimeout(() => {
      if (this.isCookieAccepted()) {
        this.cookie = this.isCookieAccepted()

      }

    }, 0)

    if (isPlatformBrowser(this.platformId)) {

      setTimeout(() => {
        if (this.isCookieAccepted()) {
          this.cookie = this.isCookieAccepted()

        }
        router.events.subscribe((val) => {
          this.goToTop()
        });
      }, 0)
      const font2 = new FontFace("CourierPrim", "url(assets/fonts/CourierPrime/CourierPrime-Regular.woff2");
      const font = new FontFace("Black Ops One", "url(assets/fonts/Black_Ops_One/BlackOpsOne-Regular.woff2)");
      document.fonts.add(font);
      document.fonts.add(font2);
      // document.fonts.add(font3);
      font.load();
      document.fonts.ready.then(() => {
      });




      this.cats = this.prerenderDataService.getPreloadedData(this.GET_ALL_CATS);
      if (this.cats) {
        this.cats = this.cats.sort((a, b) => (a.menuOrder ?? 0) - (b.menuOrder ?? 0));
        this.cat1 = this.cats.find(r => r.menuOrder === 1)! || this.cat1;
        this.cat2 = this.cats.find(r => r.menuOrder === 2)! || this.cat2;
        this.cat3 = this.cats.find(r => r.menuOrder === 3)! || this.cat3;
        this.chunkedCats = this.chunkArray(this.cats, 3);
        this.prefetchCategories();
      } else {
        this.cats = [];
        this.itemService.getAllCats().subscribe({
          next: (w) => {
            if (w && w.length > 0) {
              this.cats = w.sort((a, b) => (a.menuOrder ?? 0) - (b.menuOrder ?? 0));
              this.cat1 = this.cats.find(r => r.menuOrder === 1)! || this.cat1;
              this.cat2 = this.cats.find(r => r.menuOrder === 2)! || this.cat2;
              this.cat3 = this.cats.find(r => r.menuOrder === 3)! || this.cat3;
              this.chunkedCats = this.chunkArray(this.cats, 3);
              this.prefetchCategories();
            }
          },
          error: (err) => console.error('Failed to load categories', err)
        });
      }
      this.cookie = this.isCookieAccepted()
      msgService.notificationAnnounced$.subscribe(o => {
        if (o.topic === 'SIDENAV') {
          // this.sidenav.toggle()
          this.toggleDrawer()
          // this.changeDetectorRef.detectChanges()

        }
      })
      setTimeout(() => {
        if (media.matchMedia('(max-width: 840px)').matches) {
          this.isMobile = true
          // this.sidenav.close()
          this.closeDrawer()
        } else {
          this.isMobile = false
          // this.sidenav.open()
          this.openDrawer()

        }
      }, 5)
      media.matchMedia('(max-width: 840px)').addEventListener('change', (e) => {
        if (e.matches) {
          this.isMobile = true
          // this.sidenav.close()
          this.closeDrawer()
        } else {
          this.isMobile = false
          // this.sidenav.open()
          this.openDrawer()

        }
      })


      if (localStorage.getItem('sfncart')) {

      } else {
        localStorage.setItem('sfncart', JSON.stringify([]))
        localStorage.setItem('total', '00000.00')
        // this.changeDetectorRef.detectChanges()


      }
    }



  }
  goToTop() {
    this.msgService.pushNotification('SCROLL_TO_TOP', '')
    const content = this.document.querySelector('.mat-sidenav-content');
    try {
      content!.scrollTo({ top: 0 })

    } catch (error) {

    }
  }
  chunkArray<T>(arr: T[], chunkSize: number): T[][] {
    const result: T[][] = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize));
    }
    return result;
  }
  @HostListener('scroll', ['$event'])
  onScroll(event: Event) {
    this.msgService.pushNotification('scrolled', '')
    setTimeout(() => {
      this.cookie = this.isCookieAccepted()

    }, 0)

  }
  ngAfterViewInit(): void {


    if (isPlatformBrowser(this.platformId)) {
      // const content = this.document.querySelector('.mat-sidenav-content');
      // content!.addEventListener('scroll', (e) => {
      //   this.scrollPos = (content!.scrollTop);

      // }, { passive: true })

      this.msgService.notificationAnnounced$.subscribe(w => {
        if (w.topic === 'SHOW_GO_TO_TOP') {
          this.scrollPos = w.message;
        }
      })
    }



  }
  ngAfterContentChecked(): void {

  }
  ngOnInit(): void {

    if (isPlatformServer(this.platformId)) {

      this.itemService.getAllCats().subscribe(w => {
        this.cats = w.sort((a, b) => a.menuOrder! - b.menuOrder!);
        this.prerenderDataService.setPreloadedData(this.GET_ALL_CATS, this.cats);
        // this.changeDetectorRef.detectChanges()

      })
    }
  }
  closeIfMobile() {
    if (this.isMobile) {
      // this.sidenav.close()
      this.closeDrawer();
    }
  }

  private prefetchCategories(): void {
    if (!isPlatformBrowser(this.platformId) || !this.cats || this.cats.length === 0) {
      return;
    }
    const runPrefetch = () => {
      this.cats.forEach((cat, index) => {
        if (cat.slug) {
          setTimeout(() => {
            this.itemService.getItemAll(cat.slug!).subscribe();
          }, index * 200);
        }
      });
    };

    if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
      (window as any).requestIdleCallback(runPrefetch);
    } else {
      setTimeout(runPrefetch, 1500);
    }
  }

  navLabelConcat(label: string) {

    return label;

  }

  getIcon(i: string): string {
    i = APPHOST + '/' + i
    return i.replace('image', 'image/thumb/40/0.6f');
  }

  acceptCookies() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('cookie', 'YES')
      this.cookie = true;
    }
  }

  isCookieAccepted() {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('cookie') !== null
    }
    return true;
  }

  isDrawerOpen: boolean = false;

  toggleDrawer() {
    this.isDrawerOpen = !this.isDrawerOpen;
  }

  openDrawer() {
    this.isDrawerOpen = true;
  }

  closeDrawer() {
    this.isDrawerOpen = false;
  }
  closeInitialWelcomeScreen() {
    this.showWelcomeScreen = false;
  }
}
